import PropTypes from 'prop-types';
import styled from 'styled-components';
import Textarea from 'react-textarea-autosize';

import { GOTHAM_BOOK } from '../../styles/typography'

const borderColor = value => (value ? '#000' : '#CCC');

/*Styled Components*/
const TextArea = styled(Textarea)`
  height: 56px;
  border: none;
  border-bottom: 1px solid ${props => borderColor(props.value)};
  border-bottom: ${props => props.error && '1px solid red'};
  display: block;
  width: 100%;
  padding-top: 14px;
  margin-bottom: 8px;
  font-size: 28px;
  font-family: ${GOTHAM_BOOK};
  box-shadow: none;
  -webkit-appearance: none;
  resize: none;
  &:focus {
    outline: none;
    border-color: #000;
  }
`;

TextArea.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default TextArea;